const map = {
	"./Dashboard/Account/AccountEdit": [
		98453,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			8077,
			5011,
			7088,
			5893,
			5586,
			8741,
			8453
		]
	],
	"./Dashboard/Account/AccountEdit.tsx": [
		98453,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			8077,
			5011,
			7088,
			5893,
			5586,
			8741,
			8453
		]
	],
	"./Dashboard/Account/AccountList": [
		59522,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			6580,
			2073,
			5586,
			8741,
			537
		]
	],
	"./Dashboard/Account/AccountList.tsx": [
		59522,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			6580,
			2073,
			5586,
			8741,
			537
		]
	],
	"./Dashboard/Account/_AccountEdit": [
		25028,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			8077,
			5011,
			7088,
			9513,
			5586,
			8498,
			5028
		]
	],
	"./Dashboard/Account/_AccountEdit.js": [
		25028,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			8077,
			5011,
			7088,
			9513,
			5586,
			8498,
			5028
		]
	],
	"./Dashboard/Account/_AccountList": [
		90784,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			6580,
			5586,
			8498,
			916
		]
	],
	"./Dashboard/Account/_AccountList.js": [
		90784,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			6580,
			5586,
			8498,
			916
		]
	],
	"./Dashboard/Index/Home": [
		4710,
		[
			4710
		]
	],
	"./Dashboard/Index/Home.js": [
		4710,
		[
			4710
		]
	],
	"./Dashboard/Setting/CodeFirst": [
		80274,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			3743,
			9570,
			5586,
			274
		]
	],
	"./Dashboard/Setting/CodeFirst.tsx": [
		80274,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			3743,
			9570,
			5586,
			274
		]
	],
	"./Dashboard/Setting/CodeSecond": [
		91070,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			3976,
			5408,
			5586,
			1070
		]
	],
	"./Dashboard/Setting/CodeSecond.tsx": [
		91070,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			3976,
			5408,
			5586,
			1070
		]
	],
	"./Dashboard/Setting/ControlList": [
		59630,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			3005,
			5586,
			9630
		]
	],
	"./Dashboard/Setting/ControlList.tsx": [
		59630,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			3005,
			5586,
			9630
		]
	],
	"./Dashboard/Setting/CreateEnvironFirst": [
		81234,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9132
		]
	],
	"./Dashboard/Setting/CreateEnvironFirst.tsx": [
		81234,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9132
		]
	],
	"./Dashboard/Setting/CreateEnvironSecond": [
		85534,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			9392,
			2657,
			5586,
			5534
		]
	],
	"./Dashboard/Setting/CreateEnvironSecond.tsx": [
		85534,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			9392,
			2657,
			5586,
			5534
		]
	],
	"./Dashboard/Setting/CurrencySettingFirst": [
		15002,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			2103,
			5586,
			5002
		]
	],
	"./Dashboard/Setting/CurrencySettingFirst.tsx": [
		15002,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			2103,
			5586,
			5002
		]
	],
	"./Dashboard/Setting/CustomerCodeFirst": [
		91962,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			2428,
			801,
			5586,
			880
		]
	],
	"./Dashboard/Setting/CustomerCodeFirst.tsx": [
		91962,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			2428,
			801,
			5586,
			880
		]
	],
	"./Dashboard/Setting/CustomerCodeSecond": [
		7494,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			5586,
			7494
		]
	],
	"./Dashboard/Setting/CustomerCodeSecond.tsx": [
		7494,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			5586,
			7494
		]
	],
	"./Dashboard/Setting/GroupPagesFirst": [
		29602,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3743,
			1208,
			5586,
			9602
		]
	],
	"./Dashboard/Setting/GroupPagesFirst.tsx": [
		29602,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3743,
			1208,
			5586,
			9602
		]
	],
	"./Dashboard/Setting/GroupPagesSecond": [
		53646,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			3503,
			5586,
			3646
		]
	],
	"./Dashboard/Setting/GroupPagesSecond.tsx": [
		53646,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			3503,
			5586,
			3646
		]
	],
	"./Dashboard/Setting/SystemSetting": [
		3356,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			3743,
			3170,
			5586,
			3356
		]
	],
	"./Dashboard/Setting/SystemSetting.tsx": [
		3356,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			3743,
			3170,
			5586,
			3356
		]
	],
	"./Dashboard/Setting/SystemStyle": [
		35049,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			8077,
			5011,
			7088,
			3665,
			5184,
			7597,
			8498,
			7761,
			5049
		]
	],
	"./Dashboard/Setting/SystemStyle.js": [
		35049,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			8077,
			5011,
			7088,
			3665,
			5184,
			7597,
			8498,
			7761,
			5049
		]
	],
	"./Dashboard/Setting/TaxSettingFirst": [
		17440,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			4484,
			5586,
			7440
		]
	],
	"./Dashboard/Setting/TaxSettingFirst.tsx": [
		17440,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			4484,
			5586,
			7440
		]
	],
	"./Dashboard/Setting/UnitSettingFirst": [
		30913,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3743,
			1338,
			5586,
			913
		]
	],
	"./Dashboard/Setting/UnitSettingFirst.tsx": [
		30913,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3743,
			1338,
			5586,
			913
		]
	],
	"./Dashboard/Setting/_CodeFirst": [
		69867,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			7064,
			4148,
			5586,
			8498,
			9867
		]
	],
	"./Dashboard/Setting/_CodeFirst.js": [
		69867,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			7064,
			4148,
			5586,
			8498,
			9867
		]
	],
	"./Dashboard/Setting/_CodeSecond": [
		6477,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			8436,
			5586,
			8498,
			6477
		]
	],
	"./Dashboard/Setting/_CodeSecond.js": [
		6477,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			8436,
			5586,
			8498,
			6477
		]
	],
	"./Dashboard/Setting/_ControlList": [
		41340,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			7064,
			5326,
			5586,
			8498,
			8959
		]
	],
	"./Dashboard/Setting/_ControlList.js": [
		41340,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			7064,
			5326,
			5586,
			8498,
			8959
		]
	],
	"./Dashboard/Setting/_CreateEnvironFirst": [
		85709,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			5586,
			8498,
			5709
		]
	],
	"./Dashboard/Setting/_CreateEnvironFirst.js": [
		85709,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			5586,
			8498,
			5709
		]
	],
	"./Dashboard/Setting/_CreateEnvironSecond": [
		90135,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			9392,
			7064,
			2657,
			5586,
			8498,
			135
		]
	],
	"./Dashboard/Setting/_CreateEnvironSecond.js": [
		90135,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			9392,
			7064,
			2657,
			5586,
			8498,
			135
		]
	],
	"./Dashboard/Setting/_CurrencySettingFirst": [
		41617,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			7064,
			7817,
			5586,
			8498,
			1617
		]
	],
	"./Dashboard/Setting/_CurrencySettingFirst.js": [
		41617,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			7064,
			7817,
			5586,
			8498,
			1617
		]
	],
	"./Dashboard/Setting/_CustomerCodeFirst": [
		21063,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			7064,
			5586,
			8498,
			4314
		]
	],
	"./Dashboard/Setting/_CustomerCodeFirst.js": [
		21063,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			7064,
			5586,
			8498,
			4314
		]
	],
	"./Dashboard/Setting/_CustomerCodeSecond": [
		74513,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7064,
			5586,
			8498,
			5132
		]
	],
	"./Dashboard/Setting/_CustomerCodeSecond.js": [
		74513,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7064,
			5586,
			8498,
			5132
		]
	],
	"./Dashboard/Setting/_GroupPagesFirst": [
		279,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			3851,
			5586,
			8498,
			279
		]
	],
	"./Dashboard/Setting/_GroupPagesFirst.js": [
		279,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			3851,
			5586,
			8498,
			279
		]
	],
	"./Dashboard/Setting/_GroupPagesSecond": [
		34529,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			6055,
			5586,
			8498,
			4529
		]
	],
	"./Dashboard/Setting/_GroupPagesSecond.js": [
		34529,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			6055,
			5586,
			8498,
			4529
		]
	],
	"./Dashboard/Setting/_SystemSetting": [
		70797,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			9392,
			3743,
			7064,
			5184,
			8090,
			5586,
			8498,
			797
		]
	],
	"./Dashboard/Setting/_SystemSetting.js": [
		70797,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			9392,
			3743,
			7064,
			5184,
			8090,
			5586,
			8498,
			797
		]
	],
	"./Dashboard/Setting/_TaxSettingFirst": [
		69933,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			7064,
			198,
			5586,
			8498,
			9933
		]
	],
	"./Dashboard/Setting/_TaxSettingFirst.js": [
		69933,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			7064,
			198,
			5586,
			8498,
			9933
		]
	],
	"./Dashboard/Setting/_UnitSettingFirst": [
		47939,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			957,
			5586,
			8498,
			7939
		]
	],
	"./Dashboard/Setting/_UnitSettingFirst.js": [
		47939,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7064,
			957,
			5586,
			8498,
			7939
		]
	],
	"./Dashboard/SysPermission/SysPermissionFirst": [
		25299,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			8206,
			5586,
			5299
		]
	],
	"./Dashboard/SysPermission/SysPermissionFirst.tsx": [
		25299,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			8206,
			5586,
			5299
		]
	],
	"./Dashboard/SysPermission/SysPermissionSecond": [
		2237,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			2428,
			801,
			9392,
			3743,
			8236,
			5586,
			2237
		]
	],
	"./Dashboard/SysPermission/SysPermissionSecond.tsx": [
		2237,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			2428,
			801,
			9392,
			3743,
			8236,
			5586,
			2237
		]
	],
	"./Dashboard/SysPermission/_SysPermissionFirst": [
		58878,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			7064,
			875,
			5586,
			8498,
			8878
		]
	],
	"./Dashboard/SysPermission/_SysPermissionFirst.js": [
		58878,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			7064,
			875,
			5586,
			8498,
			8878
		]
	],
	"./Dashboard/SysPermission/_SysPermissionSecond": [
		76162,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			3743,
			7064,
			1833,
			5586,
			8498,
			6162
		]
	],
	"./Dashboard/SysPermission/_SysPermissionSecond.js": [
		76162,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			3743,
			7064,
			1833,
			5586,
			8498,
			6162
		]
	],
	"./Dashboard/UserDuty/UserDutyFirst": [
		84551,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			6013,
			5586,
			4551
		]
	],
	"./Dashboard/UserDuty/UserDutyFirst.tsx": [
		84551,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			7668,
			2428,
			801,
			4508,
			6013,
			5586,
			4551
		]
	],
	"./Dashboard/UserDuty/UserDutySecond": [
		12761,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			2428,
			801,
			9392,
			3526,
			3743,
			6260,
			5586,
			2761
		]
	],
	"./Dashboard/UserDuty/UserDutySecond.tsx": [
		12761,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			2428,
			801,
			9392,
			3526,
			3743,
			6260,
			5586,
			2761
		]
	],
	"./Dashboard/UserDuty/_UserDutyFirst": [
		99390,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			7064,
			3676,
			5586,
			8498,
			9390
		]
	],
	"./Dashboard/UserDuty/_UserDutyFirst.js": [
		99390,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			7064,
			3676,
			5586,
			8498,
			9390
		]
	],
	"./Dashboard/UserDuty/_UserDutySecond": [
		38882,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			3526,
			3743,
			7064,
			4345,
			5586,
			8498,
			8882
		]
	],
	"./Dashboard/UserDuty/_UserDutySecond.js": [
		38882,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			3526,
			3743,
			7064,
			4345,
			5586,
			8498,
			8882
		]
	],
	"./Dashboard/UserLevel/UserLevelFirst": [
		6907,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			2315,
			6944,
			5586,
			6907
		]
	],
	"./Dashboard/UserLevel/UserLevelFirst.tsx": [
		6907,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			2315,
			6944,
			5586,
			6907
		]
	],
	"./Dashboard/UserLevel/UserLevelSecond": [
		33061,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			9392,
			3526,
			3743,
			101,
			5586,
			3061
		]
	],
	"./Dashboard/UserLevel/UserLevelSecond.tsx": [
		33061,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			9392,
			3526,
			3743,
			101,
			5586,
			3061
		]
	],
	"./Dashboard/UserLevel/_UserLevelFirst": [
		32120,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7064,
			2315,
			3887,
			5586,
			8498,
			2120
		]
	],
	"./Dashboard/UserLevel/_UserLevelFirst.js": [
		32120,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7064,
			2315,
			3887,
			5586,
			8498,
			2120
		]
	],
	"./Dashboard/UserLevel/_UserLevelSecond": [
		10244,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			9392,
			3526,
			3743,
			7064,
			6546,
			5586,
			8498,
			244
		]
	],
	"./Dashboard/UserLevel/_UserLevelSecond.js": [
		10244,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			9392,
			3526,
			3743,
			7064,
			6546,
			5586,
			8498,
			244
		]
	],
	"./Lite/BasicSetting/AccountEdit": [
		42568,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			8077,
			5011,
			7088,
			5893,
			5586,
			8741,
			8453,
			2568
		]
	],
	"./Lite/BasicSetting/AccountEdit.tsx": [
		42568,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			8077,
			5011,
			7088,
			5893,
			5586,
			8741,
			8453,
			2568
		]
	],
	"./Lite/BasicSetting/AccountList": [
		232,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			6580,
			2073,
			5586,
			8741,
			5484
		]
	],
	"./Lite/BasicSetting/AccountList.tsx": [
		232,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			6580,
			2073,
			5586,
			8741,
			5484
		]
	],
	"./Lite/BasicSetting/CompanyFirst": [
		53940,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			9430,
			5586,
			7601,
			3940
		]
	],
	"./Lite/BasicSetting/CompanyFirst.tsx": [
		53940,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			9430,
			5586,
			7601,
			3940
		]
	],
	"./Lite/BasicSetting/CompanySecond": [
		31792,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8286
		]
	],
	"./Lite/BasicSetting/CompanySecond.tsx": [
		31792,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8286
		]
	],
	"./Lite/BasicSetting/WarehouseFirst": [
		60,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			5586,
			8769,
			60
		]
	],
	"./Lite/BasicSetting/WarehouseFirst.tsx": [
		60,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			5586,
			8769,
			60
		]
	],
	"./Lite/BasicSetting/WarehouseSecond": [
		52792,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			5884,
			5586,
			4523,
			2792
		]
	],
	"./Lite/BasicSetting/WarehouseSecond.tsx": [
		52792,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			5884,
			5586,
			4523,
			2792
		]
	],
	"./Lite/Commodity/CommodityListFirst": [
		72647,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120,
			2647
		]
	],
	"./Lite/Commodity/CommodityListFirst.tsx": [
		72647,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120,
			2647
		]
	],
	"./Lite/Commodity/CommodityListSecond": [
		1305,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236,
			1305
		]
	],
	"./Lite/Commodity/CommodityListSecond.tsx": [
		1305,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236,
			1305
		]
	],
	"./Lite/Commodity/CommoditySortFirst": [
		3595,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576,
			3595
		]
	],
	"./Lite/Commodity/CommoditySortFirst.tsx": [
		3595,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576,
			3595
		]
	],
	"./Lite/Commodity/StockPutInFirst": [
		60452,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6250
		]
	],
	"./Lite/Commodity/StockPutInFirst.tsx": [
		60452,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6250
		]
	],
	"./Lite/Commodity/StockPutInSecond": [
		57184,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			2428,
			801,
			5586,
			7184
		]
	],
	"./Lite/Commodity/StockPutInSecond.tsx": [
		57184,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			2428,
			801,
			5586,
			7184
		]
	],
	"./Lite/CustomerManagement/CustomerFirst": [
		10304,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			3769,
			5586,
			304
		]
	],
	"./Lite/CustomerManagement/CustomerFirst.tsx": [
		10304,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			3769,
			5586,
			304
		]
	],
	"./Lite/CustomerManagement/CustomerLevelFirst": [
		5288,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			5219,
			5586,
			5288
		]
	],
	"./Lite/CustomerManagement/CustomerLevelFirst.tsx": [
		5288,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			5219,
			5586,
			5288
		]
	],
	"./Lite/CustomerManagement/CustomerSecond": [
		89908,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			5586,
			8741,
			5751,
			9908
		]
	],
	"./Lite/CustomerManagement/CustomerSecond.tsx": [
		89908,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			5586,
			8741,
			5751,
			9908
		]
	],
	"./Lite/Index/Home": [
		81412,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			3665,
			3179,
			5586,
			8498,
			7761,
			3123,
			1412
		]
	],
	"./Lite/Index/Home.tsx": [
		81412,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			3665,
			3179,
			5586,
			8498,
			7761,
			3123,
			1412
		]
	],
	"./Lite/InventoryControl/InvAdjustFirst": [
		18964,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			7946
		]
	],
	"./Lite/InventoryControl/InvAdjustFirst.tsx": [
		18964,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			7946
		]
	],
	"./Lite/InventoryControl/InvAdjustSecond": [
		45392,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			5392
		]
	],
	"./Lite/InventoryControl/InvAdjustSecond.tsx": [
		45392,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			5392
		]
	],
	"./Lite/InventoryControl/StockReport": [
		17480,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			2750,
			7480
		]
	],
	"./Lite/InventoryControl/StockReport.tsx": [
		17480,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			2750,
			7480
		]
	],
	"./Lite/OfficeSiteSetting/OfficeSiteFirst": [
		47179,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			3743,
			8077,
			5011,
			2638,
			9197,
			5586,
			7223,
			3874,
			7179
		]
	],
	"./Lite/OfficeSiteSetting/OfficeSiteFirst.tsx": [
		47179,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			3743,
			8077,
			5011,
			2638,
			9197,
			5586,
			7223,
			3874,
			7179
		]
	],
	"./Lite/OrderManagement/OrderFirst": [
		7896,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8006
		]
	],
	"./Lite/OrderManagement/OrderFirst.tsx": [
		7896,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8006
		]
	],
	"./Lite/OrderManagement/OrderPickingFirst": [
		87349,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			7088,
			9609,
			5586,
			8498,
			3222,
			7349
		]
	],
	"./Lite/OrderManagement/OrderPickingFirst.tsx": [
		87349,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			7088,
			9609,
			5586,
			8498,
			3222,
			7349
		]
	],
	"./Lite/OrderManagement/OrderReturnFirst": [
		25590,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9096
		]
	],
	"./Lite/OrderManagement/OrderReturnFirst.tsx": [
		25590,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9096
		]
	],
	"./Lite/OrderManagement/OrderReturnSecond": [
		15818,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			7088,
			2582,
			5586,
			6323,
			5818
		]
	],
	"./Lite/OrderManagement/OrderReturnSecond.tsx": [
		15818,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			7088,
			2582,
			5586,
			6323,
			5818
		]
	],
	"./Lite/OrderManagement/OrderSecond": [
		80364,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7175,
			5586,
			1380,
			9053,
			364
		]
	],
	"./Lite/OrderManagement/OrderSecond.tsx": [
		80364,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7175,
			5586,
			1380,
			9053,
			364
		]
	],
	"./Lite/PromotionSetting/PromoAllFirst": [
		68702,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			2315,
			3751,
			5586,
			8498,
			3861,
			8702
		]
	],
	"./Lite/PromotionSetting/PromoAllFirst.tsx": [
		68702,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			2315,
			3751,
			5586,
			8498,
			3861,
			8702
		]
	],
	"./Lite/PromotionSetting/PromoDIY": [
		74117,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			1773,
			5586,
			8741,
			1641,
			4117
		]
	],
	"./Lite/PromotionSetting/PromoDIY.tsx": [
		74117,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			1773,
			5586,
			8741,
			1641,
			4117
		]
	],
	"./Lite/PromotionSetting/PromotionAllSecond": [
		80916,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			1773,
			7972,
			5586,
			8498,
			145,
			8535
		]
	],
	"./Lite/PromotionSetting/PromotionAllSecond.tsx": [
		80916,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			1773,
			7972,
			5586,
			8498,
			145,
			8535
		]
	],
	"./Lite/SellSetting/SellSettingFirst": [
		55379,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			7533,
			5586,
			5379
		]
	],
	"./Lite/SellSetting/SellSettingFirst.tsx": [
		55379,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			7533,
			5586,
			5379
		]
	],
	"./Lite/SellSetting/SellSettingSecond": [
		61309,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			5586,
			8741,
			7223,
			7822,
			1309
		]
	],
	"./Lite/SellSetting/SellSettingSecond.tsx": [
		61309,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			5586,
			8741,
			7223,
			7822,
			1309
		]
	],
	"./Stock/Commodity/CommodityListFirst": [
		72533,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120,
			2533
		]
	],
	"./Stock/Commodity/CommodityListFirst.tsx": [
		72533,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120,
			2533
		]
	],
	"./Stock/Commodity/CommodityListSecond": [
		80311,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236,
			311
		]
	],
	"./Stock/Commodity/CommodityListSecond.tsx": [
		80311,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236,
			311
		]
	],
	"./Stock/Commodity/CommoditySortFirst": [
		51241,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576,
			1241
		]
	],
	"./Stock/Commodity/CommoditySortFirst.tsx": [
		51241,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576,
			1241
		]
	],
	"./Stock/CommodityTag/CommodiyTagFirst": [
		71811,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3743,
			8957,
			5586,
			1811
		]
	],
	"./Stock/CommodityTag/CommodiyTagFirst.tsx": [
		71811,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3743,
			8957,
			5586,
			1811
		]
	],
	"./Stock/Company/CompanyFirst": [
		67601,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			9430,
			5586,
			7601
		]
	],
	"./Stock/Company/CompanyFirst.tsx": [
		67601,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			9430,
			5586,
			7601
		]
	],
	"./Stock/Company/CompanySecond": [
		10555,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8529
		]
	],
	"./Stock/Company/CompanySecond.tsx": [
		10555,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8529
		]
	],
	"./Stock/Import/ImportListFirst": [
		94705,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			8077,
			5011,
			2315,
			5586,
			8741,
			9950
		]
	],
	"./Stock/Import/ImportListFirst.tsx": [
		94705,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			8077,
			5011,
			2315,
			5586,
			8741,
			9950
		]
	],
	"./Stock/Import/ImportListSecond": [
		42651,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7088,
			5897,
			5586,
			8741,
			2651
		]
	],
	"./Stock/Import/ImportListSecond.tsx": [
		42651,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7088,
			5897,
			5586,
			8741,
			2651
		]
	],
	"./Stock/Index/Home": [
		69136,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			7064,
			5586,
			8498,
			9005
		]
	],
	"./Stock/Index/Home.js": [
		69136,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			264,
			2428,
			801,
			9392,
			7064,
			5586,
			8498,
			9005
		]
	],
	"./Stock/InventoryControl/InvAdjustFirst": [
		44010,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6916
		]
	],
	"./Stock/InventoryControl/InvAdjustFirst.tsx": [
		44010,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6916
		]
	],
	"./Stock/InventoryControl/InvAdjustSecond": [
		19382,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			9382
		]
	],
	"./Stock/InventoryControl/InvAdjustSecond.tsx": [
		19382,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			9382
		]
	],
	"./Stock/InventoryControl/InvMonthFirst": [
		67403,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			3526,
			216,
			2704,
			3153,
			3767,
			5586,
			8741,
			7403
		]
	],
	"./Stock/InventoryControl/InvMonthFirst.tsx": [
		67403,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			4508,
			3526,
			216,
			2704,
			3153,
			3767,
			5586,
			8741,
			7403
		]
	],
	"./Stock/InventoryControl/InvMonthSecond": [
		36373,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			2428,
			801,
			5586,
			9763
		]
	],
	"./Stock/InventoryControl/InvMonthSecond.tsx": [
		36373,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			2428,
			801,
			5586,
			9763
		]
	],
	"./Stock/InventoryControl/InvRequisitionFirst": [
		30697,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			2891
		]
	],
	"./Stock/InventoryControl/InvRequisitionFirst.tsx": [
		30697,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			2891
		]
	],
	"./Stock/InventoryControl/InvRequisitionSecond": [
		73587,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			3587
		]
	],
	"./Stock/InventoryControl/InvRequisitionSecond.tsx": [
		73587,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			3587
		]
	],
	"./Stock/InventoryControl/InvScrapFirst": [
		74468,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			2170
		]
	],
	"./Stock/InventoryControl/InvScrapFirst.tsx": [
		74468,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			2170
		]
	],
	"./Stock/InventoryControl/InvScrapSecond": [
		21682,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			1682
		]
	],
	"./Stock/InventoryControl/InvScrapSecond.tsx": [
		21682,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			1682
		]
	],
	"./Stock/InventoryControl/InvTransferFirst": [
		35846,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5448
		]
	],
	"./Stock/InventoryControl/InvTransferFirst.tsx": [
		35846,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5448
		]
	],
	"./Stock/InventoryControl/InvTransferSecond": [
		40026,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			26
		]
	],
	"./Stock/InventoryControl/InvTransferSecond.tsx": [
		40026,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5100,
			26
		]
	],
	"./Stock/Purchase/PurchaseListFirst": [
		97361,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8771
		]
	],
	"./Stock/Purchase/PurchaseListFirst.tsx": [
		97361,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8771
		]
	],
	"./Stock/Purchase/PurchaseListSecond": [
		80603,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7088,
			8309,
			5586,
			8741,
			1380,
			603
		]
	],
	"./Stock/Purchase/PurchaseListSecond.tsx": [
		80603,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			7088,
			8309,
			5586,
			8741,
			1380,
			603
		]
	],
	"./Stock/Stock/StockListFirst": [
		64785,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			4785
		]
	],
	"./Stock/Stock/StockListFirst.tsx": [
		64785,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			4785
		]
	],
	"./Stock/Stock/StockListSecond": [
		15995,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			2241
		]
	],
	"./Stock/Stock/StockListSecond.tsx": [
		15995,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			2241
		]
	],
	"./Stock/StockPutIn/StockPutInFirst": [
		42019,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6250,
			2019
		]
	],
	"./Stock/StockPutIn/StockPutInFirst.tsx": [
		42019,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6250,
			2019
		]
	],
	"./Stock/StockPutIn/StockPutInSecond": [
		23469,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			2428,
			801,
			5586,
			3469
		]
	],
	"./Stock/StockPutIn/StockPutInSecond.tsx": [
		23469,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			948,
			6487,
			2428,
			801,
			5586,
			3469
		]
	],
	"./Stock/StockReport/StockManageReport": [
		78534,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			8534
		]
	],
	"./Stock/StockReport/StockManageReport.tsx": [
		78534,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			8534
		]
	],
	"./Stock/StockReport/StockReport": [
		36815,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			2750,
			6815
		]
	],
	"./Stock/StockReport/StockReport.tsx": [
		36815,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			2750,
			6815
		]
	],
	"./Stock/Utility/CommodityListFirst": [
		74120,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120
		]
	],
	"./Stock/Utility/CommodityListFirst.tsx": [
		74120,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120
		]
	],
	"./Stock/Utility/CommodityListSecond": [
		42236,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236
		]
	],
	"./Stock/Utility/CommodityListSecond.tsx": [
		42236,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236
		]
	],
	"./Stock/Utility/CommoditySortFirst": [
		97576,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576
		]
	],
	"./Stock/Utility/CommoditySortFirst.tsx": [
		97576,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576
		]
	],
	"./Stock/Warehouse/WarehouseFirst": [
		38769,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			5586,
			8769
		]
	],
	"./Stock/Warehouse/WarehouseFirst.tsx": [
		38769,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			5586,
			8769
		]
	],
	"./Stock/Warehouse/WarehouseSecond": [
		14523,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			5884,
			5586,
			4523
		]
	],
	"./Stock/Warehouse/WarehouseSecond.tsx": [
		14523,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			5884,
			5586,
			4523
		]
	],
	"./Stock/Wine/WineListFirst": [
		32753,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120,
			2753
		]
	],
	"./Stock/Wine/WineListFirst.tsx": [
		32753,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			2638,
			7113,
			5586,
			8741,
			7223,
			4120,
			2753
		]
	],
	"./Stock/Wine/WineListSecond": [
		13979,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236,
			3979
		]
	],
	"./Stock/Wine/WineListSecond.tsx": [
		13979,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			8027,
			5586,
			8741,
			7223,
			2236,
			3979
		]
	],
	"./Stock/Wine/WineSortFirst": [
		45477,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576,
			5477
		]
	],
	"./Stock/Wine/WineSortFirst.tsx": [
		45477,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			216,
			8077,
			5011,
			5684,
			5586,
			7576,
			5477
		]
	],
	"./WebContent/CustomerManagement/BonusImportLog": [
		94165,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			4959
		]
	],
	"./WebContent/CustomerManagement/BonusImportLog.tsx": [
		94165,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			4959
		]
	],
	"./WebContent/CustomerManagement/CustomerFirst": [
		12963,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			3769,
			5586,
			2963
		]
	],
	"./WebContent/CustomerManagement/CustomerFirst.tsx": [
		12963,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			3769,
			5586,
			2963
		]
	],
	"./WebContent/CustomerManagement/CustomerLevelFirst": [
		72445,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			5219,
			5586,
			2445
		]
	],
	"./WebContent/CustomerManagement/CustomerLevelFirst.tsx": [
		72445,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			7668,
			2428,
			801,
			4508,
			3743,
			5219,
			5586,
			2445
		]
	],
	"./WebContent/CustomerManagement/CustomerSecond": [
		38413,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			5586,
			8741,
			5751
		]
	],
	"./WebContent/CustomerManagement/CustomerSecond.tsx": [
		38413,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			5586,
			8741,
			5751
		]
	],
	"./WebContent/Index/Home": [
		13123,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			3665,
			3179,
			5586,
			8498,
			7761,
			3123
		]
	],
	"./WebContent/Index/Home.js": [
		13123,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			3665,
			3179,
			5586,
			8498,
			7761,
			3123
		]
	],
	"./WebContent/InvoiceManagement/OrderInvoiceDetail": [
		8708,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			4666
		]
	],
	"./WebContent/InvoiceManagement/OrderInvoiceDetail.tsx": [
		8708,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			4666
		]
	],
	"./WebContent/LogisticsSetting/LogisticsFirst": [
		38446,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			1111,
			5586,
			8446
		]
	],
	"./WebContent/LogisticsSetting/LogisticsFirst.tsx": [
		38446,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			264,
			7668,
			2428,
			801,
			4508,
			9392,
			3743,
			1111,
			5586,
			8446
		]
	],
	"./WebContent/LogisticsSetting/LogisticsSecond": [
		14850,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			730,
			5586,
			4850
		]
	],
	"./WebContent/LogisticsSetting/LogisticsSecond.tsx": [
		14850,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			730,
			5586,
			4850
		]
	],
	"./WebContent/OfficeSiteSetting/OfficeSiteFirst": [
		13874,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			3743,
			8077,
			5011,
			2638,
			9197,
			5586,
			7223,
			3874
		]
	],
	"./WebContent/OfficeSiteSetting/OfficeSiteFirst.tsx": [
		13874,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			3743,
			8077,
			5011,
			2638,
			9197,
			5586,
			7223,
			3874
		]
	],
	"./WebContent/OrderManagement/Order": [
		97209,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			9392,
			216,
			3743,
			8077,
			5011,
			7654,
			4302,
			5586,
			7209
		]
	],
	"./WebContent/OrderManagement/Order.tsx": [
		97209,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			163,
			4508,
			9392,
			216,
			3743,
			8077,
			5011,
			7654,
			4302,
			5586,
			7209
		]
	],
	"./WebContent/OrderManagement/OrderFirst": [
		75443,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5017
		]
	],
	"./WebContent/OrderManagement/OrderFirst.tsx": [
		75443,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5017
		]
	],
	"./WebContent/OrderManagement/OrderPickingFirst": [
		33222,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			7088,
			9609,
			5586,
			8498,
			3222
		]
	],
	"./WebContent/OrderManagement/OrderPickingFirst.js": [
		33222,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			7088,
			9609,
			5586,
			8498,
			3222
		]
	],
	"./WebContent/OrderManagement/OrderReturnFirst": [
		58713,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5915
		]
	],
	"./WebContent/OrderManagement/OrderReturnFirst.tsx": [
		58713,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			5915
		]
	],
	"./WebContent/OrderManagement/OrderReturnSecond": [
		76323,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			7088,
			2582,
			5586,
			6323
		]
	],
	"./WebContent/OrderManagement/OrderReturnSecond.tsx": [
		76323,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			7088,
			2582,
			5586,
			6323
		]
	],
	"./WebContent/OrderManagement/OrderSecond": [
		49053,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7175,
			5586,
			1380,
			9053
		]
	],
	"./WebContent/OrderManagement/OrderSecond.tsx": [
		49053,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			7175,
			5586,
			1380,
			9053
		]
	],
	"./WebContent/OrderManagement/OrderShipFirst": [
		93133,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			3743,
			7064,
			6381,
			5586,
			8498,
			3133
		]
	],
	"./WebContent/OrderManagement/OrderShipFirst.js": [
		93133,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			3743,
			7064,
			6381,
			5586,
			8498,
			3133
		]
	],
	"./WebContent/OrderManagement/_OrderReturnFirst": [
		24632,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			5586,
			8498,
			4632
		]
	],
	"./WebContent/OrderManagement/_OrderReturnFirst.js": [
		24632,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			9392,
			3526,
			216,
			2704,
			3153,
			7064,
			4145,
			5586,
			8498,
			4632
		]
	],
	"./WebContent/OrderManagement/_OrderReturnSecond": [
		55492,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			7064,
			7088,
			1561,
			5586,
			8498,
			5492
		]
	],
	"./WebContent/OrderManagement/_OrderReturnSecond.js": [
		55492,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			7064,
			7088,
			1561,
			5586,
			8498,
			5492
		]
	],
	"./WebContent/OrderMessage/OrderMessageFirst": [
		55352,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			4199,
			5586,
			8741,
			8793,
			8844,
			8518
		]
	],
	"./WebContent/OrderMessage/OrderMessageFirst.tsx": [
		55352,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3153,
			4199,
			5586,
			8741,
			8793,
			8844,
			8518
		]
	],
	"./WebContent/PaymentSetting/PaymentFirst": [
		1616,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7049,
			5586,
			1616
		]
	],
	"./WebContent/PaymentSetting/PaymentFirst.tsx": [
		1616,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3743,
			7049,
			5586,
			1616
		]
	],
	"./WebContent/PromotionSetting/PromoAllFirst": [
		43861,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			2315,
			3751,
			5586,
			8498,
			3861
		]
	],
	"./WebContent/PromotionSetting/PromoAllFirst.js": [
		43861,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			2315,
			3751,
			5586,
			8498,
			3861
		]
	],
	"./WebContent/PromotionSetting/PromoDIY": [
		74632,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			1773,
			5586,
			8741,
			1641
		]
	],
	"./WebContent/PromotionSetting/PromoDIY.tsx": [
		74632,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			1773,
			5586,
			8741,
			1641
		]
	],
	"./WebContent/PromotionSetting/PromotionAllSecond": [
		20145,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			1773,
			7972,
			5586,
			8498,
			145
		]
	],
	"./WebContent/PromotionSetting/PromotionAllSecond.js": [
		20145,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			7064,
			4145,
			3976,
			1773,
			7972,
			5586,
			8498,
			145
		]
	],
	"./WebContent/Report/AdjustDetailReport": [
		17056,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			238
		]
	],
	"./WebContent/Report/AdjustDetailReport.tsx": [
		17056,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			238
		]
	],
	"./WebContent/Report/CustomerReport": [
		75186,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			3526,
			216,
			2704,
			3153,
			3259,
			5586,
			8741,
			5186
		]
	],
	"./WebContent/Report/CustomerReport.tsx": [
		75186,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			3526,
			216,
			2704,
			3153,
			3259,
			5586,
			8741,
			5186
		]
	],
	"./WebContent/Report/OrderRevenue": [
		40340,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6842
		]
	],
	"./WebContent/Report/OrderRevenue.tsx": [
		40340,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			6842
		]
	],
	"./WebContent/Report/OrderSaleDetail": [
		31380,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8746
		]
	],
	"./WebContent/Report/OrderSaleDetail.tsx": [
		31380,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			8746
		]
	],
	"./WebContent/Report/OrderSaleSummary": [
		52519,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9189
		]
	],
	"./WebContent/Report/OrderSaleSummary.tsx": [
		52519,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9189
		]
	],
	"./WebContent/Report/PromotionReport": [
		11179,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9233
		]
	],
	"./WebContent/Report/PromotionReport.tsx": [
		11179,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			9233
		]
	],
	"./WebContent/Report/ScrapDetailReport": [
		23956,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			1482
		]
	],
	"./WebContent/Report/ScrapDetailReport.tsx": [
		23956,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			1482
		]
	],
	"./WebContent/Report/StockReport": [
		32750,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			2750
		]
	],
	"./WebContent/Report/StockReport.tsx": [
		32750,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			5586,
			2750
		]
	],
	"./WebContent/Report/StockTransferReport": [
		93671,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			3845
		]
	],
	"./WebContent/Report/StockTransferReport.tsx": [
		93671,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			3526,
			216,
			2704,
			3153,
			5586,
			8741,
			3845
		]
	],
	"./WebContent/SellSetting/SellSettingFirst": [
		37824,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			7533,
			5586,
			7824
		]
	],
	"./WebContent/SellSetting/SellSettingFirst.tsx": [
		37824,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			2428,
			801,
			163,
			7533,
			5586,
			7824
		]
	],
	"./WebContent/SellSetting/SellSettingSecond": [
		47822,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			5586,
			8741,
			7223,
			7822
		]
	],
	"./WebContent/SellSetting/SellSettingSecond.tsx": [
		47822,
		[
			5185,
			2816,
			7000,
			7434,
			8591,
			4043,
			948,
			6487,
			264,
			7668,
			2428,
			801,
			163,
			4508,
			9392,
			3526,
			216,
			2704,
			3743,
			3153,
			3976,
			2638,
			5586,
			8741,
			7223,
			7822
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95567;
module.exports = webpackAsyncContext;